<template>
  <div>
    <div class="page-main has-bottom">
      <page-title />
      <page-card style="margin-bottom:32px">
        <template slot="header">
          Producer Information
        </template>
        <div slot="body">
          <base-info :page-data.sync="pageData" />
          <div class="add-header">
            Well Information
          </div>
          <pointComp
            v-for="(group, index) in reviewList"
            ref="pointComp"
            :key="'group' + index"
            :page-data="group"
            :point-index="index"
            :annual-review="true"
          />
        </div>
      </page-card>
    </div>
    <page-bottom>
      <template>
        <div class="page-btns">
          <loading-btn type="primary" label="Submit" @clickHandle="submit" />
        </div>
      </template>
    </page-bottom>
    <editInformationSuccess
      ref="editInformationSuccess"
      @close="closeSuccess"
    />
  </div>
</template>

<script>
import pointComp from '@/views/wellManage/myWells/pointInfo.vue'
import baseInfo from '@/views/wellManage/myWells/baseInfo.vue'
import editInformationSuccess from '@/views/authentication/editInformationSuccess.vue'

export default {
  components: {
    pointComp,
    editInformationSuccess,
    baseInfo
  },
  data() {
    return {
      pageData: {
        accAddress: undefined,
        companyName: undefined,
        wellLicense: undefined
      },
      reviewList: []
    }
  },
  computed: {},
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      const resData = this.$store.getters.annualInfo
      this.pageData = resData.producer
      this.reviewList = this.normalizeReviewList(resData)
    },
    normalizeReviewList(resData) {
      const reviewList = [];
      (resData.pointList || []).forEach((item) => {
        if (Array.isArray(item.wells) && item.wells.length > 0) {
          reviewList.push(item)
        }
      });
      (resData.wellList || []).forEach((well) => {
        reviewList.push({
          location: well.location,
          location_id: well.location_id,
          wells: [well]
        })
      })
      return reviewList
    },
    submit(btn) {
      let pointFlag = true
      if (this.$refs.pointComp && this.$refs.pointComp.length > 0) {
        this.$refs.pointComp.forEach((i, index) => {
          pointFlag = this.$refs.pointComp[index].check()
          if (!pointFlag) {
            btn.closeLoad()
            return
          }
        })
      }
      if (!pointFlag) {
        btn.closeLoad()
        return
      }
      if (pointFlag) {
        const httpList = []
        if (this.$refs.pointComp && this.$refs.pointComp.length > 0) {
          this.$refs.pointComp.forEach((i, index) => {
            httpList.push(...this.$refs.pointComp[index].updateWell())
          })
        }

        Promise.all(httpList)
          .then(values => {
            this.$refs.editInformationSuccess.open(undefined)
            btn.closeLoad()
          })
          .catch(err => {
            console.log(err)
            btn.closeLoad()
          })
      }
    },
    closeSuccess() {
      this.$router.push('/index')
      setTimeout(() => {
        location.reload()
      }, 1000)
    }
  }
}
</script>
<style scoped lang="scss">
.page-main {
  ::v-deep .page-card .page-card_head {
    border-bottom: none;
  }
  ::v-deep .page-card .page-card_body {
    padding-top: 0;
  }
  .add-header {
    padding: 0.24 rem 0.32 rem;
    border-bottom: 1 px solid #f0f0f0;
    font-size: 0.22rem;
    font-weight: bold;
    margin: 0.24rem 0;
  }
}
</style>
